<!-- START: Mobile navbar -->
<div class="yt-m-navbar d-flex flex-row align-items-center">
  <div class="yt-m-brand d-flex flex-row align-items-center">
    <svg class="yt-m-logo" viewBox="0 0 24 17" aria-hidden="true" focusable="false">
      <rect width="24" height="17" rx="5" ry="5" fill="#ff0000" />
      <polygon points="9.6,4.4 17,8.5 9.6,12.6" fill="#fff" />
    </svg>
    <span class="yt-m-wordmark">YouTube</span>
  </div>

  <div class="yt-m-navbar-icons d-flex flex-row align-items-center ms-auto">
    <i class="bi bi-cast"></i>
    <i class="bi bi-bell"></i>
    <i class="bi bi-search"></i>
  </div>
</div>
<!-- END: Mobile navbar -->
